export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/rest_day-9689800561ea6179557df6d48c5ab0ec.svg";